import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import RouterIcon from '@mui/icons-material/Router';
import CardTable from 'components/CardTable/CardTable';
import RegularButton from 'components/CustomButtons/Button';
import { ModalV2 } from 'components/Modal/ModalV2';
import { TableInputs } from 'components/CardTable/TableInputs';
import { useSearch } from 'hooks/useSearch';
import { useRuleValidator } from 'hooks/useRuleValidator';
import { PERMISSIONS } from 'router/permissions';
import {
  getIotDevices,
  addIotDeviceMode,
  resetIotDeviceSelected,
  setIotDevicesFilters,
} from 'redux/actions/iotDevices/iotDevicesActions';
import { iotDevicesTypes } from 'redux/reducers/iotDevices/iotDevicesTypes';
import { columns } from './columns';
import { IotDeviceForm } from './IotDeviceForm';
import { IotDeviceAssignForm } from './IotDeviceAssignForm';
import { IotDeviceUnassignForm } from './IotDeviceUnassignForm';

const tableKey = 'iotDevices';

export const IotDevicesView = () => {
  const dispatch = useDispatch();
  const { buildTableConfig, buildCompLoadings, setSnackbar } = useSearch();
  const { iotDevicesList, addMode, station } = useSelector(({ iotDevices }) => iotDevices);
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const canCreate = useRuleValidator(PERMISSIONS.IOT_DEVICES_CREATE);

  const [openForm, setOpenForm] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);
  const [openUnassign, setOpenUnassign] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar('Selecciona una planta', 'warning');
      return;
    }
    dispatch(getIotDevices(station.id));
  };

  const handleClose = () => {
    dispatch(resetIotDeviceSelected());
    setOpenForm(false);
    setOpenAssign(false);
    setOpenUnassign(false);
  };

  const handleOpenEdit = (device) => {
    dispatch({ type: iotDevicesTypes.SET_IOT_DEVICE_SELECTED, payload: device });
    dispatch({ type: iotDevicesTypes.EDIT_IOT_DEVICE_MODE });
    setOpenForm(true);
  };

  const handleOpenAssign = (device) => {
    dispatch({ type: iotDevicesTypes.SET_IOT_DEVICE_SELECTED, payload: device });
    setOpenAssign(true);
  };

  const handleOpenUnassign = (device) => {
    dispatch({ type: iotDevicesTypes.SET_IOT_DEVICE_SELECTED, payload: device });
    setOpenUnassign(true);
  };

  const handleOpenAdd = () => {
    dispatch(addIotDeviceMode());
    setOpenForm(true);
  };

  useEffect(() => {
    dispatch(resetIotDeviceSelected());
    buildCompLoadings(['loadingIotDevices']);
    if (!configTables?.[tableKey]) buildTableConfig(tableKey);
  }, []);

  return (
    <>
      <CardTable
        data={iotDevicesList}
        columns={columns(handleOpenEdit, handleOpenAssign, handleOpenUnassign)}
        isLoading={isLoadingComp?.loadingIotDevices}
        blockBtn
        tableKey={tableKey}
        hasHeader
        icon={<RouterIcon />}
        title="Dispositivos IoT"
        tableContent={
          <TableInputs
            reducer="iotDevices"
            stations
            dispatchAction={setIotDevicesFilters}
            submitLoadingKey="loadingIotDevices"
            submitAction={handleSubmit}
          />
        }
        hasControl
        controls={
          canCreate && (
            <RegularButton round justIcon color="info" onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          )
        }
      />

      <ModalV2
        open={openForm}
        title={addMode ? 'Nuevo dispositivo IoT' : 'Editar dispositivo IoT'}
        toRight
        onClose={handleClose}
      >
        <IotDeviceForm onClose={handleClose} />
      </ModalV2>

      <ModalV2
        open={openAssign}
        title="Vincular a tanque comodato"
        toRight
        onClose={handleClose}
      >
        <IotDeviceAssignForm onClose={handleClose} />
      </ModalV2>

      <ModalV2
        open={openUnassign}
        title="Desvincular dispositivo"
        toRight
        onClose={handleClose}
      >
        <IotDeviceUnassignForm onClose={handleClose} />
      </ModalV2>
    </>
  );
};
